// Generated by Melange

import * as Buhta_cabinet__Api from "../../../../core/Api.js";
import * as Buhta_cabinet__Bisb from "../../../../core/Bisb.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Crm from "../../../../models/Crm.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__Form from "../../../../core/Form.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_cabinet__Request from "../../../../core/Request.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_cabinet__Select from "../../../html/Select.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import CloseSvg from "static/icons/close.svg";

function NewTicketPanel(Props) {
  let onClose = Props.onClose;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const match$2 = React.useState(function () {
        
      });
  const setOrg = match$2[1];
  const org = match$2[0];
  const match$3 = React.useState(function () {
        return "";
      });
  const setSubject = match$3[1];
  const subject = match$3[0];
  const match$4 = React.useState(function () {
        return "";
      });
  const setMessage = match$4[1];
  const message = match$4[0];
  const submit = function (param) {
    const __x = Curry._3(Buhta_cabinet__Bisb.CrmService.TicketService.createTicket, tenant.ctx, param[0], param[1]);
    return $$Promise.flatMap(__x, (function (result) {
                  if (result.TAG === /* Ok */0) {
                    Curry._1(dispatchToasts, {
                          TAG: /* Add */0,
                          _0: {
                            id: Buhta_core__Toast.generateId(undefined),
                            text: "Тикет успешно создан",
                            kind: "success",
                            onClick: (function (param) {
                                
                              })
                          }
                        });
                    Buhta_cabinet__Route.navigateTo({
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Help */3,
                            _0: /* Tickets */{
                              _0: {
                                TAG: /* View */0,
                                _0: result._0.id
                              }
                            }
                          }
                        });
                  } else {
                    Curry._1(dispatchToasts, {
                          TAG: /* Add */0,
                          _0: {
                            id: Buhta_core__Toast.generateId(undefined),
                            text: result._0.message,
                            kind: "warning",
                            onClick: (function (param) {
                                
                              })
                          }
                        });
                  }
                  return $$Promise.resolved(result);
                }));
  };
  const form = Buhta_cabinet__Form.useForm(submit);
  const formSubmitHandler = function (param) {
    if (org !== undefined) {
      Curry._1(form.submit, [
            org.value,
            {
              body: message,
              type_: "opened",
              subject: subject
            }
          ]);
      return ;
    }
    
  };
  const arg = Buhta_cabinet__Crm.Org.grid;
  const arg$1 = Curry._2(Buhta_cabinet__Api.Endpoints.Crm.orgs, undefined, undefined);
  return JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
              title: "Новый запрос",
              titleAlign: "left",
              textSize: "m",
              leftActions: {
                hd: JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(CloseSvg, {}),
                      onClick: (function (param) {
                          Curry._1(onClose, undefined);
                        })
                    }),
                tl: /* [] */0
              },
              className: "h-full",
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("form", {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Select.Searchable.make, {
                                        label: "Выбрать предприятие",
                                        useFetch: (function (param) {
                                            const func = function (param$1, param$2, param$3) {
                                              return Buhta_cabinet__Request.useGrid(param, arg$1, param$1, param$2, param$3);
                                            };
                                            return function (param) {
                                              return Curry._2(func, param, arg);
                                            };
                                          }),
                                        mapper: (function (item) {
                                            return {
                                                    value: item.id,
                                                    text: item.name
                                                  };
                                          }),
                                        selectedOption: org,
                                        onChange: (function (org) {
                                            Curry._1(setOrg, (function (param) {
                                                    return org;
                                                  }));
                                          }),
                                        labelFloating: false
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Тема",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setSubject, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: subject
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Текст запроса",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setMessage, (function (param) {
                                                    return value;
                                                  }));
                                          }),
                                        multiline: true,
                                        className: "mt-4",
                                        value: message
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                        state: form.isSubmitting ? "Loading" : "Default",
                                        type_: "submit",
                                        className: "mt-6",
                                        disabled: form.isSubmitting,
                                        children: "Создать запрос"
                                      })
                                ],
                                onSubmit: (function (ev) {
                                    formSubmitHandler(undefined);
                                    ev.preventDefault();
                                  })
                              }),
                          className: "flex flex-col w-106"
                        }),
                    className: "flex items-center justify-center p-6"
                  })
            });
}

const make = NewTicketPanel;

export {
  make ,
}
/* Buhta_cabinet__Bisb Not a pure module */
